import {FC, ReactNode, useState} from 'react'
import {useLocation} from 'react-router'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {checkIsActive, KTSVG} from '../../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
  variant?: 'default' | 'download'
  badge?: ReactNode
}

const MenuItem: FC<Props> = ({
  to,
  title,
  icon,
  fontIcon,
  hasArrow = false,
  hasBullet = false,
  variant = 'default',
  badge,
}) => {
  const {pathname} = useLocation()
  const [hover, setHover] = useState(false)
  const isRequestPage = () => {
    return pathname.includes('/request-') && to.includes('/request-add-products')
  }
  
  
  return (
    <div className='menu-item me-lg-1'>
      <Link
        className={clsx('menu-link py-3', {
          'active menu-here': checkIsActive(pathname, to) || isRequestPage(),
        })}
        to={to}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={
          variant === 'download' || to === '/download-app'
            ? {
                background: hover
                  ? 'linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)'
                  : 'linear-gradient(135deg, #1CB5E0 0%, #000851 100%)',
                color: '#fff',
                borderRadius: 10,
                padding: '8px 14px',
              }
            : undefined
        }
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}

        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        <span className='menu-title' style={(variant === 'download' || to === '/download-app') ? {color: '#fff'} : undefined}>{title}{badge}</span>

        {hasArrow && <span className='menu-arrow'></span>}
      </Link>
    </div>
  )
}

export {MenuItem}
